import { Component, OnInit, ViewChild } from '@angular/core';
import { FormComponentComponent } from 'src/app/components/form-component/form-component.component';
import { FileService } from 'src/app/services/file.service';
import { FormServices } from 'src/app/services/form-services.service';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { environment } from 'src/environments/environment';
import { AnswerAndQuestionComponent } from './test-components/answer-and-question/answer-and-question.component';

@Component({
  selector: 'app-virtual-class',
  templateUrl: './virtual-class.page.html',
  styleUrls: ['./virtual-class.page.scss'],
})
export class VirtualClassPage implements OnInit {
  @ViewChild('formComponent') formComponent: FormComponentComponent;
  @ViewChild('answerAndQuestions')
  answerAndQuestions: AnswerAndQuestionComponent;
  public value = 'learningModules';
  public buttons = [
    {
      value: 'learningModules',
      name: 'Módulos',
    },
    {
      value: 'learningLessons',
      name: 'Clases',
    },
    {
      value: 'learningTests',
      name: 'Examen',
    },
    {
      value: 'finishedTests',
      name: 'Exámenes Realizados',
    },
  ];

  fieldForms: any;
  domainId = environment.domainId;
  isUploading = false;
  savedForm: any;
  id: number;

  constructor(
    private formSv: FormServices,
    private httpSv: HttpService,
    private uiSv: UiServices,
    private fileSv: FileService
  ) {}

  ngOnInit() {
    this.getForms();
  }

  changedSegment(newSegment: string) {
    this.id = undefined;
    this.savedForm = undefined;
    this.value = newSegment;
    this.fieldForms = undefined;
    setTimeout(() => {
      this.getForms();
    });
  }

  async getForms() {
    try {
      const res = await this.formSv.getForm(this.value, this.domainId);
      this.fieldForms = res;
      console.log('this.fieldForms :>> ', this.fieldForms);
    } catch (err) {
      console.error(err);
    }
  }

  async sendInfo(ev: FormData) {
    try {
      if (ev) {
        if (this.value === 'learningTests') {
          ev.set(
            'testQuestion',
            JSON.stringify(this.answerAndQuestions.testQuestions)
          );
        }
        this.id && ev.set('id', String(this.id));
        this.isUploading = true;
        const res: any = await this.httpSv.itemAction(
          ev,
          this.value,
          this.id ? 'update' : 'store'
        );
        this.isUploading = false;
        await this.uiSv.showToast('Guardado exitosamente');
        if (res.status) {
          this.id = undefined;
          if (this.answerAndQuestions) {
            this.answerAndQuestions.testQuestions = [];
          }
          this.formSv.clearFormSrc.next();
          this.formSv.deleteListProductSrc.next('reloadListProduct');
        }
      }
    } catch (err) {
      console.error(err);
    }
  }

  sendData() {
    this.formComponent.submitInfo();
  }

  async getCategories({ product, action, changeAction }) {
    try {
      const { id, savedForm } = await this.fileSv.getProduct(
        { product, action, changeAction },
        this.id,
        this.value,
        'Item',
        this.savedForm
      );
      this.id = id;
      savedForm.condicionalDate = isNaN(+savedForm.condicionalDate)
        ? savedForm.condicionalDate
        : +savedForm.condicionalDate;
      this.savedForm = savedForm;
      if (this.value === 'learningTests') {
        savedForm.question.forEach((item) => {
          if (item.answer) {
            item.answers = item.answer;
            delete item.answer;
            item.reponsesQuantity = item.answers.length;
          }
        });

        setTimeout(() => {
          const copy = JSON.parse(JSON.stringify(savedForm.question));
          if (action === 'copy') {
            copy.forEach((item) => {
              item.answers.forEach((ans) => {
                delete ans.id;
              });
              delete item.id;
            });
          }
          this.answerAndQuestions.testQuestions =
            action === 'copy' ? copy : savedForm.question;
        }, 1000);
      }
    } catch (err) {
      console.error(err);
      await this.uiSv.loading?.dismiss();
    }
  }
}
